import * as React from 'react';
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import { MultiSelect } from 'primereact/multiselect';
import { Skeleton } from 'primereact/skeleton';

import * as UtilsActions from '../../store/ducks/utils/actions';
import { ApplicationState } from "../../store";

function ListaTrilha({
    utils,
    getTrilhaList,
    trilhas,
    onChangeTrilhas,
    error
}: any) {

    const [trilhaList, setTrilhasList] = React.useState<any>([]);
    const [trilhaSelecionados, setTrilhasSelecionados] = React.useState<any>([]);
    const [selectAll, setSelectAll] =  React.useState(false);
    const [lazyItems, setLazyItems] = React.useState<any>([]);
    const [lazyLoading, setLazyLoading] = React.useState(false);

    const loadLazyTimeout = React.useRef<null | ReturnType<typeof setTimeout>>(null);

    React.useEffect(() => {
        getTrilhaList()
    }, []);

    React.useEffect(() => {
        if(utils.data.trilhas){
            setTrilhasList(utils.data.trilhas);
            if(utils.data.trilhas.length > 0){
                setSelectAll(trilhas.length == utils.data.trilhas.length);
            }
        }
    }, [utils.data.trilhas]);

    React.useEffect(() => {
        if(trilhas){
            setTrilhasSelecionados(trilhas.map((item: any) => item.idTrilha));
        }
    }, [trilhas])

    const onLazyLoad = (event: any) => {
        setLazyLoading(true);

        if (loadLazyTimeout.current) {
            clearTimeout(loadLazyTimeout.current);
        }

        loadLazyTimeout.current = setTimeout(() => {
            const { first, last } = event;
            const _lazyItems = [...lazyItems];

            for (let i = first; i < last; i++) {
                _lazyItems[i] = { label: `Item #${i}`, value: i };
            }

            setLazyItems(_lazyItems);
            setLazyLoading(false);
        }, 300);
    }

    return (
        <MultiSelect 
            style={{
                width: '100%'
            }}
            value={trilhaSelecionados} 
            options={trilhaList} 
            display="chip"
            onChange={(e) => {
                if(e.value){
                    setTrilhasSelecionados(e.value); 
                    setSelectAll(e.value.length === trilhaList.length);
                    onChangeTrilhas(trilhaList.filter((tri: any) => e.value.includes(tri.idTrilha)));
                } else {
                    setTrilhasSelecionados([])
                    setSelectAll(false);
                    onChangeTrilhas([])
                }
            }} 
            selectAll={selectAll} 
            optionLabel="nmTrilha"
            optionValue='idTrilha'
            placeholder="Selecione as Trilhas" 
            filter 
            showClear={true}
            className={error ? "p-multiselect-error" : ''}
            maxSelectedLabels={3} 
            selectedItemsLabel={`${trilhaSelecionados ? trilhaSelecionados.length : 0} trilhas selecionadas`}
            emptyFilterMessage='Não encontrado'
            filterPlaceholder='Busque por uma trilha'
            resetFilterOnHide={true}
            virtualScrollerOptions={{ lazy: true, onLazyLoad: onLazyLoad, itemSize: 43, showLoader: true, loading: lazyLoading, delay: 1, loadingTemplate: (options) => {
                return (
                    <div className="flex align-items-center p-2" style={{ height: '43px' }}>
                        <Skeleton width={options.even ? '70%' : '60%'} height="1.5rem" />
                    </div>
                )}
            }} 
        />
    );
}

const mapStateToProps = (state: ApplicationState) => ({
    utils: state.utils
});
  
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({...UtilsActions}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ListaTrilha);